

import { Prop, Component } from 'vue-property-decorator';
import { mixins } from "vue-class-component";
import { ProxyTableData } from '../ProxyTableData';

@Component
export default class SortComponent extends mixins(
  ProxyTableData
) {
  @Prop() column!: any
  @Prop() setSelectedKeys!: any
  @Prop() selectedKeys!: any
  @Prop() confirm!: any
  @Prop() vif!: any[]
  localVif = [] as any[]

  // Отслеживаем скролл и если открыта сортировка, то скрываем ее при скролле
  beforeMount() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    scrollr?.addEventListener('scroll', this.handleWindowScroll);
  }

  beforeDestroy() {
    const scrollr = document.querySelector('.layout ') as HTMLElement;
    scrollr?.removeEventListener('scroll', this.handleWindowScroll);
  }

  handleWindowScroll() {
    const elements = document.querySelectorAll('.ant-dropdown') as NodeListOf<HTMLElement>;

    elements.forEach(element => {
      const existingStyle = element.getAttribute('style');
      if (!existingStyle || !existingStyle.includes('display')) {
        element.style.display = 'none';
      }
    });
  }

  setFilter(sort_by: string, sort: any): void {
    this.$emit('setFilter', { by: sort_by, sort: sort })
  }

  clearFilter(clear: string): void {
    this.$emit('clearFilter', clear)
  }

  clearSearchText() {
    this.setSelectedKeys([]);
  }

  async handleSearchFromHead(selectedKeys: string[], confirm: boolean, dataIndex: string): Promise<void> {
    if (dataIndex === "name") this.proxyFilter = { name: selectedKeys[0] }
    if (dataIndex === "phone") this.proxyFilter = { phone: selectedKeys[0] }
    await this.sortData('on', this.column)
  }
  mounted(): void {
    this.localVif = this.vif; // Update localVif with the prop's value
  }

  //handleSearchLite(selectedKeys: any, confirm: any, column: any): void {}
}
